import { __extends } from "tslib";
import * as React from 'react';
import { translate } from 'react-i18next';
import ListItem from '../common/ListItem';
import AddItem from '../common/AddItem';
import DeleteCustomFieldModal from './DeleteCutomFieldModal/DeleteCustomFieldModal';
import * as css from './ManageCustomFields.scss';
import * as Icons from '../../assets/icons';
import AddCustomFieldModal from '../AddCustomFieldModal/AddCustomFieldModal';
import { Modal, MessageBoxFunctionalLayout, Text } from 'wix-style-react';
var ManageCustomFields = /** @class */ (function (_super) {
    __extends(ManageCustomFields, _super);
    function ManageCustomFields() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isAddOpen: false,
            listContainerRef: null,
        };
        _this.handleOnAddCustomField = function (addedCustomField) {
            _this.setState({ isAddOpen: false });
            _this.props.onAdd(addedCustomField);
        };
        _this.handleAddCustomFieldClicked = function () { return _this.setState({ isAddOpen: true }); };
        _this.handleOnCloseAddCustomField = function () {
            _this.setState({ isAddOpen: false });
            _this.props.onCloseAddCustomField();
        };
        _this.renderLearnMore = function () { return (React.createElement(Text, { dataHook: "learn-more-custom-field" },
            React.createElement("a", { href: "https://support.wix.com/en/article/manage-your-contacts-fields", target: "_blank", rel: "noopener noreferrer" }, _this.props.t('learnMore')))); };
        return _this;
    }
    ManageCustomFields.prototype.handleStartEdit = function (customField) {
        this.setState({ fieldToEdit: customField });
    };
    ManageCustomFields.prototype.handleUpdate = function (customField, newName) {
        this.props.onUpdate(customField, newName);
        this.setState({ fieldToEdit: null });
    };
    ManageCustomFields.prototype.handleDeleteClick = function (fieldToDelete) {
        this.setState({ fieldToDelete: fieldToDelete });
    };
    ManageCustomFields.prototype.handleCancelEdit = function () {
        this.setState({ fieldToEdit: null });
    };
    ManageCustomFields.prototype.handleDeleteConfirm = function () {
        this.props.onDelete(this.state.fieldToDelete);
        this.setState({ fieldToDelete: null });
    };
    ManageCustomFields.prototype.handleDeleteCancel = function () {
        this.setState({ fieldToDelete: null });
    };
    ManageCustomFields.prototype.renderCustomFieldsList = function () {
        var _this = this;
        var _a = this.props, t = _a.t, customFields = _a.customFields, validateUniqueCustomField = _a.validateUniqueCustomField;
        var _b = this.state, fieldToEdit = _b.fieldToEdit, listContainerRef = _b.listContainerRef;
        return (React.createElement("div", null,
            React.createElement("div", { className: css.customFieldsContainer, ref: function (el) {
                    if ((el && !listContainerRef) ||
                        (el && el.clientWidth !== listContainerRef.clientWidth)) {
                        _this.setState({ listContainerRef: el });
                    }
                } }, customFields.map(function (customField, i) { return (React.createElement(ListItem, { dataHook: "field-" + i, key: customField.name, name: customField.name, mode: customField === fieldToEdit ? 'edit' : 'view', onUpdate: function (newName) { return _this.handleUpdate(customField, newName); }, onDelete: function () { return _this.handleDeleteClick(customField); }, onStartEdit: function () { return _this.handleStartEdit(customField); }, onCancelEdit: function () { return _this.handleCancelEdit(); }, validateUniqueItem: validateUniqueCustomField, icon: ManageCustomFields.iconsMap[customField.type], deleteTooltipText: t('itemDeleteButtonTooltip'), renameTooltipText: t('itemRenameButtonTooltip'), alreadyExistsText: function (customFieldName) {
                    return t('customFieldExists', { customFieldName: customFieldName });
                } })); })),
            React.createElement("div", { style: {
                    width: listContainerRef && listContainerRef.clientWidth,
                    visibility: !listContainerRef ? 'hidden' : 'visible',
                } },
                React.createElement(AddItem, { dataHook: "add-field-button", onClick: this.handleAddCustomFieldClicked }, t('customFieldsManagerAddField')))));
    };
    ManageCustomFields.prototype.renderDeleteModal = function () {
        var _this = this;
        return (React.createElement(DeleteCustomFieldModal, { isOpen: !!this.state.fieldToDelete, onCancel: function () { return _this.handleDeleteCancel(); }, onConfirm: function () { return _this.handleDeleteConfirm(); } }));
    };
    ManageCustomFields.prototype.render = function () {
        var _a = this.props, t = _a.t, isOpen = _a.isOpen, onClose = _a.onClose, validateUniqueCustomField = _a.validateUniqueCustomField;
        var fieldToEdit = this.state.fieldToEdit;
        return (React.createElement(Modal, { dataHook: "manage-custom-field-modal", isOpen: isOpen, onRequestClose: onClose },
            React.createElement(MessageBoxFunctionalLayout, { dataHook: "manage-custom-fields-box", confirmText: t('customFieldsManagerDone'), buttonsHeight: "medium", onOk: onClose, onClose: onClose, title: t('customFieldsManagerTitle'), width: "583px", disableConfirmation: !!fieldToEdit },
                React.createElement(Text, { "data-hook": "custom-field-manager-notice" }, t('CustomFieldsManagerNotice')),
                this.renderLearnMore(),
                this.renderCustomFieldsList()),
            this.renderDeleteModal(),
            React.createElement(AddCustomFieldModal, { onAdd: this.handleOnAddCustomField, onClose: this.handleOnCloseAddCustomField, validateUniqueCustomField: validateUniqueCustomField, isOpen: this.state.isAddOpen })));
    };
    ManageCustomFields.iconsMap = {
        text: React.createElement(Icons.text, null),
        date: React.createElement(Icons.date, null),
        url: React.createElement(Icons.url, null),
        number: React.createElement(Icons.number, null),
    };
    return ManageCustomFields;
}(React.Component));
export default translate()(ManageCustomFields);
//# sourceMappingURL=ManageCustomFields.js.map